export default "__VITE_ASSET__Bjs4L45w__"